// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__mALXW","legal":"Footer_legal__BdbAs","version":"Footer_version__BIcR0","env":"Footer_env__D20+N","footerContainer":"Footer_footer-container__a9hqD"};